'use client';

import { c as _c } from "react/compiler-runtime";
import { signOut } from 'next-auth/react';
import MainHeaderComponent, { type Props } from '@openclassrooms/common-app/header/components/MainHeader';
import OCAuthSDK from '@openclassrooms/auth-sdk';
export default function MainHeader(t0) {
  const $ = _c(3);
  const {
    isWide: t1,
    additionalMenu
  } = t0;
  const isWide = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== additionalMenu || $[1] !== isWide) {
    t2 = <MainHeaderComponent additionalMenu={additionalMenu} onLogOut={_temp} isWide={isWide} />;
    $[0] = additionalMenu;
    $[1] = isWide;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
async function _temp() {
  OCAuthSDK.storageCleanUp();
  await signOut({
    redirect: false
  });
  document.location.href = "/";
}